import axios from "axios";

const fetchQcEventHistory = async (payload) => {
  return new Promise((resolve, reject) => {
    axios.get('analytic/api/v1/petworld/qr-credit-reporting/qc-events', payload)
      .then((response) => resolve(response.data))
      .catch((error) => {
          return reject(error.response.data);
      });
  })
};

export default fetchQcEventHistory;